<template>
  <div>
    <!-- 用于创建订单的中转站 目前因为技术原因暂未使用（支付宝环境页面空白） -->
  </div>
</template>

<script>
import api from "../../api/api-list"

export default {
  mounted () {
    this.createOrderFunc()
  },
  methods: {
    // 创建订单
    createOrderFunc () {
      // 获取 支付类型 和 创建订单的唯一 id（前端生成）
      let { type, orderId } = this.$route.query

      // 支付类型 c端照片美颜
      if (type === 'cPhotoBeauty') {
        this.createPhotoBeautyOrderFunc(type, orderId)
      }

    },
    // 创建 c端照片美颜 订单
    async createPhotoBeautyOrderFunc (type, orderId) {
      try {
        let params = {
           photo_key: orderId
        }
        let res = await api.global.createPhotoBeautyOrder(params)
        if (res.code === 1000) {
          // 真正的订单 token
          let orderToken = res.data.token
          this.toPayPageFunc(type, orderToken)
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 跳转到支付页面
    toPayPageFunc (type, orderId) {
      this.$router.push({
        path: '/pay/type',
        query: {
          type,
          orderId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
